import type { Key, ReactNode } from 'react';
import React from 'react';
import { useStyletron } from 'baseui';
import { VIRTUAL_AXIS } from './constants';
import type { VirtualItemT } from './types';
import { VirtualTrack } from './virtual-track';
type ColumnStripPropsT = {
  /** Total scrollable body width in px. */
  width: number;
  items: VirtualItemT[];
  scrollMargin: number;
  getKey: (index: number) => Key;
  renderCell: (columnIndex: number) => ReactNode;
};

/** Sized, relatively-positioned container for the column-axis {@link VirtualTrack}. */
export const ColumnStrip = ({
  width,
  items,
  scrollMargin,
  getKey,
  renderCell
}: ColumnStripPropsT) => {
  const [css] = useStyletron();
  return <div className={css({
    position: 'relative',
    flexShrink: 0,
    width: `${width}px`,
    height: '100%'
  })}>
      <VirtualTrack items={items} axis={VIRTUAL_AXIS.column} scrollMargin={scrollMargin} getKey={getKey} renderItem={renderCell} />
    </div>;
};